export default __webpack_public_path__ + "static/media/mobile-modal-qr-code.fa69dab8.png";